<div class="w-full h-full flex flex-col p-8">
	<div>
		<app-button (click)="goToImpersonate()">Impersonate</app-button>
	</div>
</div>
